export const VERSION = typeof "3.4.15" !== 'undefined' ? "3.4.15" : 'latest';
//# sourceMappingURL=version.js.map